import { useUIContext } from "../context/UIContext/UIContext";
import { SocialLinkOption } from "../components/SocialsInput/SocialsInput";
import { FaInstagram } from "react-icons/fa";
import { CiFacebook } from "react-icons/ci";
import { RiFacebookCircleLine } from "react-icons/ri";
import { IoLogoTiktok } from "react-icons/io5";
import { FaSpotify } from "react-icons/fa6";
import { FaXTwitter } from "react-icons/fa6";
import { FaThreads } from "react-icons/fa6";
import { FaApple } from "react-icons/fa";
import { PiYoutubeLogo } from "react-icons/pi";
import { FaSoundcloud } from "react-icons/fa6";
import { FaBandcamp } from "react-icons/fa";
import { FaVimeo } from "react-icons/fa";
import websiteIcon from "../assets/icons/website.svg";
import Icon from "../components/Icon/Icon";
import { TbWorld } from "react-icons/tb";

export const FacebookSocialIcon = props => {
  const isDark = Boolean(useUIContext()?.darkMode);
  const FbIcon = isDark ? RiFacebookCircleLine : CiFacebook;
  return <FbIcon {...props} />;
};

export const socialOptions = [
  {
    rawIcon: FaInstagram,
    icon: (
      <FaInstagram size={25} color="var(--inyc-primary-text-color-light)" />
    ),
    id: "instagram",
    patterns: ["instagram.com"],
    buildProfileUrl: (handle) => `https://www.instagram.com/${handle}`,
  },
  {
    rawIcon: IoLogoTiktok,
    icon: (
      <IoLogoTiktok size={25} color="var(--inyc-primary-text-color-light)" />
    ),
    id: "tiktok",
    patterns: ["tiktok.com"],
    buildProfileUrl: (handle) => `https://www.tiktok.com/@${handle}`,
  },
  {
    rawIcon: FacebookSocialIcon,
    icon: (
      <FacebookSocialIcon size={25} color="var(--inyc-primary-text-color-light)" />
    ),
    id: "facebook",
    patterns: ["facebook.com", "fb.com"],
    buildProfileUrl: (handle) => `https://www.facebook.com/${handle}`,
  },
  {
    rawIcon: FaSpotify,
    icon: <FaSpotify size={25} color="var(--inyc-primary-text-color-light)" />,
    id: "spotify",
    patterns: ["spotify.com"],
  },
  {
    rawIcon: FaXTwitter,
    icon: <FaXTwitter size={25} color="var(--inyc-primary-text-color-light)" />,
    id: "twitter",
    patterns: ["twitter.com", "x.com"],
    buildProfileUrl: (handle) => `https://x.com/${handle}`,
  },
  {
    rawIcon: FaThreads,
    icon: <FaThreads size={25} color="var(--inyc-primary-text-color-light)" />,
    id: "threads",
    patterns: ["threads.com", "threads.net"],
    buildProfileUrl: (handle) => `https://www.threads.com/@${handle}`,
  },
  {
    rawIcon: FaApple,
    icon: <FaApple size={25} color="var(--inyc-primary-text-color-light)" />,
    id: "apple",
    patterns: ["music.apple.com", "itunes.apple.com"],
  },
  {
    rawIcon: FaSoundcloud,
    icon: (
      <FaSoundcloud size={25} color="var(--inyc-primary-text-color-light)" />
    ),
    id: "soundcloud",
    patterns: ["soundcloud.com"],
  },
  {
    rawIcon: PiYoutubeLogo,
    icon: <PiYoutubeLogo size={25} color="var(--inyc-primary-text-color-light)" />,
    id: "youtube",
    patterns: ["youtube.com", "youtu.be"],
  },
  {
    rawIcon: FaBandcamp,
    icon: <FaBandcamp size={25} color="var(--inyc-primary-text-color-light)" />,
    id: "bandcamp",
    patterns: ["bandcamp.com"],
  },
  {
    rawIcon: FaVimeo,
    icon: <FaVimeo size={25} color="var(--inyc-primary-text-color-light)" />,
    id: "vimeo",
    patterns: ["vimeo.com"],
  },
  {
    rawIcon: TbWorld,
    icon: (
      <TbWorld size={25} color="var(--inyc-primary-text-color-light)" />
    ),
    id: "website",
    patterns: [], // No specific patterns; fallback for unmatched links
  },
];

export const getSocialOptionById = (id) =>
  socialOptions.find((opt) => opt.id === id);

export const isValidSocialHandle = (handle) => /^[a-zA-Z0-9._]+$/.test(handle);

export const getSocialIcon = (social) => {
  return (
    socialOptions.find((opt) => opt.id === social)?.icon || (
      <Icon
        className="!w-[25px] invert-[var(--inyc-lighten-white)]"
        src={websiteIcon}
      />
    )
  );
};
